<template>
  <button
    @click="updateResidenceStatus"
    :class="{
      'is-active': selected === true,
    }"
    type="button"
    class="c-btn c-btn--invisible"
  >
    <Toggle
      :isSelected="selected"
      class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
    />Vis bare ledige
  </button>
</template>

<script>
// Models
import Availability from '@/models/Availability';
import Residence from '@/models/Residence';

// Components
import Toggle from '@/components/Toggle.vue';

export default {
  name: 'SelectResidenceStatus',
  components: {
    Toggle,
  },
  computed: {
    residenceStatus() {
      return this.$store.state.entities.residences.residenceStatus;
    },
    selected() {
      if (this.residenceStatus === 'for-sale') {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (localStorage.residenceStatus) {
      this.setResidenceStatus(localStorage.residenceStatus);
    }
  },
  methods: {
    updateResidenceStatus() {
      if (this.residenceStatus === 'all') {
        Residence.commit(state => {
          state.residenceStatus = 'for-sale';
        });
        this.$gtag.event('Vis bare ledige',{
          event_category: 'Filter',
          event_label: 'hide_not_for_sale',
        });
      } else {
        Residence.commit(state => {
          state.residenceStatus = 'all';
        });
        this.$gtag.event('Vis alle (salgsstatus)', {
          event_category: 'Filter',
          event_label: 'show_not_for_sale',
        });
      }
      localStorage.setItem('residenceStatus', this.residenceStatus);
    },
    setResidenceStatus(residenceStatus) {
      Residence.commit(state => {
        state.residenceStatus = residenceStatus;
      });
    },
  },
};
</script>
